import {
    Col,
    Divider,
    Row,
    Space,
    Typography,
} from 'antd';
import {
    FC,
    memo,
} from 'react';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '../PageHeader';
import ItemData from './Item';
import { IBooking } from '../../interfaces/booking.interface';
import { ETA } from './ETA';
import { EBookingStatus } from '../../enums/booking.enum';

const { Title } = Typography;

const Delivery: FC<Partial<IBooking>> = ({
    driverName,
    deliveryAddress,
    deliveryReferences,
    pickupAddress,
    pickupReferences,
    distanceBreakUp: distance,
    estimatedTimeToPointA,
    estimatedTimeToPointB,
    statusUpdates,
    statusText,
}) => {
    const { t } = useTranslation('bookings', { keyPrefix: 'DETAIL' });
    return (
        <Space direction="vertical" size={12}>
            <PageHeader
                title={(
                    <Title level={5} style={{ marginBottom: 0 }}>
                        {t('DELIVERY_INFORMATION')}
                    </Title>
                )}
                footer={<Divider />}
            />

            <Row justify="space-between" align="middle" style={{ width: '100%' }} gutter={[24, 24]}>
                <Col xs={24} xxl={24}>
                    <Space direction="vertical" size={12}>

                        <ItemData
                            label={t('DRIVER_NAME')}
                            value={driverName || t('NOT_ASSIGNED')}
                        />

                        {/* TODO: Add phone certification */}
                        {/* <ItemData
                            label={t('DRIVER_MOBILE')}
                            value={(
                                <Space size={16}>
                                    {
                                        phoneFormatted && (
                                            <Space
                                                size={4}
                                                style={{ cursor: 'pointer' }}
                                                onClick={phoneFormatted !== null ? () => window.open(`https://wa.me/${phoneFormatted}`, '_blank') : () => { }}
                                            >
                                                <AiOutlineWhatsApp
                                                    color="var(--color-primary)"
                                                    size={16}
                                                    style={{ verticalAlign: 'middle' }}
                                                />
                                                {phoneFormatted || '-'}
                                            </Space>
                                        )
                                    }
                                </Space>
                            )}
                            actionRequired
                        /> */}

                        <ItemData
                            label={t('LOCATIONS.PICKUP')}
                            value={(
                                <Space size={2} direction="vertical">
                                    {pickupAddress}
                                    {
                                        (!pickupReferences || pickupReferences === 'N/A')
                                            ? t('LOCATIONS.NO_REFERENCE')
                                            : pickupReferences
                                    }
                                </Space>
                            )}
                        />

                        <ItemData
                            label={t('LOCATIONS.DELIVER')}
                            value={(
                                <Space size={2} direction="vertical">
                                    {deliveryAddress}
                                    {
                                        (!deliveryReferences || deliveryReferences === 'N/A')
                                            ? t('LOCATIONS.NO_REFERENCE')
                                            : deliveryReferences
                                    }
                                </Space>
                            )}
                        />

                        <ETA
                            estimatedTimeToPointA={estimatedTimeToPointA || 0}
                            estimatedTimeToPointB={estimatedTimeToPointB || 0}
                            statusUpdates={statusUpdates || []}
                            statusText={statusText as EBookingStatus}
                        />

                        <ItemData
                            label={t('LOCATIONS.DISTANCE_COVERED')}
                            value={`${distance?.billedDistance?.toFixed(2)} Km`}
                        />
                    </Space>
                </Col>
            </Row>
        </Space>
    );
};

export default memo(Delivery);
